"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_notes_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/add_notes.svg"));
var assured_workload_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/assured_workload.svg"));
var box_add_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/box_add.svg"));
var contract_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/contract.svg"));
var create_new_folder_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/create_new_folder.svg"));
var description_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/description.svg"));
var download_svg_1 = __importDefault(require("../../../assets/icons/acoes/download.svg"));
var draft_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/draft.svg"));
var folder_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/folder.svg"));
var folder_off_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/folder_off.svg"));
var list_alt_add_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/list_alt_add.svg"));
var image_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/image.svg"));
var new_release_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/new_release.svg"));
var note_add_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/note_add.svg"));
var request_page_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/request_page.svg"));
var overview_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/overview.svg"));
var model_training_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/model_training.svg"));
var route_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/route.svg"));
var scan_delete_svg_1 = __importDefault(require("../../../assets/icons/arquivos_e_dados/scan_delete.svg"));
var ArquivosEDados = {
    "add_notes": add_notes_svg_1.default,
    "assured_workload": assured_workload_svg_1.default,
    "box_add": box_add_svg_1.default,
    "contract": contract_svg_1.default,
    "create_new_folder": create_new_folder_svg_1.default,
    "description": description_svg_1.default,
    "download": download_svg_1.default,
    "draft": draft_svg_1.default,
    "folder": folder_svg_1.default,
    "folder_off": folder_off_svg_1.default,
    "image": image_svg_1.default,
    "list_alt_add": list_alt_add_svg_1.default,
    "model_training": model_training_svg_1.default,
    "new_release": new_release_svg_1.default,
    "note_add": note_add_svg_1.default,
    "overview": overview_svg_1.default,
    "request_page": request_page_svg_1.default,
    "route": route_svg_1.default,
    "scan_delete": scan_delete_svg_1.default,
};
exports.default = ArquivosEDados;
